<template>
  <div class="download">
   <!-- 头部 -->
		<zmlmenupage cn-name='下载' en-name='Download Center'></zmlmenupage>
    <!-- 下载内容 -->
    <div class="download-container">
      <h2 class="title">水运版</h2>
      <div class="download-item-box">
        <div class="download-item-box-li">
          <img src="../../static/img/app_share_ship_merchant-app-logo.png" alt="">
          <p>货运江湖船运货主版iOS端</p>
          <button class="download-button download-blue" @click="download('merchantIos')">下载</button>
        </div>
        <div class="download-item-box-li">
          <img src="../../static/img/app_share_ship_merchant-app-logo.png" alt="">
          <p>货运江湖水运货主版Android端</p>
           <button class="download-button download-blue" @click="download('mercnahtAndroid')">下载</button>
        </div>
      </div>
      <div class="download-item-box">
        <div class="download-item-box-li">
          <img src="../../static/img/app_share_shipper-app-logo.png" alt="">
          <p>货运江湖船东版iOS端</p>
           <button class="download-button download-or" @click="download('shipperIos')">下载</button>
        </div>
        <div class="download-item-box-li">
          <img src="../../static/img/app_share_shipper-app-logo.png" alt="">
          <p>货运江湖船东版Android端</p>
           <button class="download-button download-or" @click="download('shipperAndroid')">下载</button>
        </div>
        <div class="download-item-box-li">
          <img class="border-r" src="../../static/img/app_share_shipper-app-logo.png" alt="">
          <p>货运江湖船东版小程序</p>
          <button class="download-button download-or" @click="download('mercnahtCode')">访问</button>
        </div>
      </div>
      <h2 class="title">汽运版</h2>
      <div class="download-item-box flexCenter">
        <div class="download-item-box-li m-l-0">
          <img src="../../static/img/app_share_merchant-app-logo.png" alt="">
          <p>货运江湖汽运货主版iOS端</p>
          <button class="download-button download-blue" @click="download('qyMerchantIos')">下载</button>
        </div>
        <div class="download-item-box-li">
          <img src="../../static/img/app_share_merchant-app-logo.png" alt="">
          <p>货运江湖汽运货主版Android端</p>
          <button class="download-button download-blue" @click="download('qyMerchantIosAndroid')">下载</button>
        </div>
      </div>
      <div class="download-item-box flexCenter">
        <div class="download-item-box-li m-l-0">
          <img src="../../static/img/app_share_driver-app-logo.png" alt="">
          <p>货运江湖司机版iOS端</p>
          <button class="download-button download-or" @click="download('driverIos')">下载</button>
        </div>
        <div class="download-item-box-li">
          <img src="../../static/img/app_share_driver-app-logo.png" alt="">
          <p>货运江湖司机版Android端</p>
          <button class="download-button download-or" @click="download('driverAndroid')">下载</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'download',

  data() {
    return {
      
    };
  },
  methods: {
    //跳转到应用介绍页面
    download(type) {
      this.$router.push({
        name: "applicationDetails",
        params: {
          type: type,
        }
      });
    }
  },
};
</script>

<style  scoped="scoped">
  .download-container {
    padding: 100px 0;
    width: 1400px;
    height: 100%;
    margin: auto;
  }
  .title {
    width: 100%;
    height: auto;
    padding: 50px 0 40px;
    text-align: center;
    font-size: 30px;
    color: #282828;
  }
  .download-item-box-li {
    width: 350px;
    height: 350px;
    background: rgba(255,255,255,1);
    -webkit-box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.1);
    margin-left: 87px;
    margin-bottom: 70px;
    display: inline-block;
    text-align: center;
    font-size: 20px;
    box-sizing: border-box;
    overflow: hidden;
}
 .download-item-box-li > img {
    margin: 54px auto 34px;;
    width: 122px;
    border: 1px solid #f0f0f0;
    border-radius: 18%;
 }
 .download-button {
    width: 146px;
    height: 40px;
    line-height: 40px;
    display: inline-block;
    border-radius: 10em;
    margin: 6% auto;
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    cursor: pointer;
 }
 .download-blue {
  background: -webkit-gradient(linear, right top, left top, from(#22a2ff), to(#58cdfe));
  background: linear-gradient(-90deg, #22a2ff, #58cdfe);
 }
 .download-or {
  background: -webkit-gradient(linear, right top, left top, from(#fc9930), to(#ffd080));
  background: linear-gradient(-90deg, #fc9930 1%, #ffd080 97%);
 }
 .download-item-box-li > img.border-r {
  border-radius: 50%;
 }
 .m-l-0 {
  margin-left: 0px;
 }
 @media only screen and (max-width: 750px)  {
   .download-container {
      width: 90%;
      padding: 15px 0px;
   }
   .download-item-box-li {
     width: 48%;
    height: 248px;
    margin-left: 0px;
    margin-bottom: 4px;
    font-size: 16px;
    margin-right: 4px;
    padding: 0 10px;
   }
   .download-item-box-li:nth-of-type(2n) {
    margin-right: 0px;
   }
   .download-item-box-li > img {
    margin: 36px auto 24px;
    width: 64px;
   }
   .download-button {
    width: 115px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
   }
 }
</style>


// WEBPACK FOOTER //
// src/pages/download.vue